import {useState} from "react";
import Shell from "../../components/shell";
import {useCreatePartner, useUpdatePartner} from "../../hooks/use-partner";
import PartnersTable from "../../components/partners-table";
import PartnerForm from "../../components/partners-form";

const PartnersPage = () => {
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const createMut = useCreatePartner();
  const updateMut = useUpdatePartner();

  const onSubmit = async (payload) => {
    if (editing?._id) {
      await updateMut.mutateAsync({id: editing._id, payload});
      setEditing(null);
      setOpen(false);
      return;
    }
    await createMut.mutateAsync(payload);
    setOpen(false);
  };

  const headerBtnAction = {
    isActive: true,
    title: "+ New Partner",
    onClick: () => {
      setEditing(null);
      setOpen(true);
    },
  };
  return (
    <Shell
      pageHeader="Create and View Partners"
      pageTitle="Partners"
      btnAction={headerBtnAction}
    >
      <div>
        <div>
          <PartnersTable />

          {open ? (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4">
              <div className="w-full max-w-lg rounded-lg bg-white p-6 shadow-lg">
                <div className="mb-4 flex items-center justify-between">
                  <h2 className="text-lg font-semibold">
                    {editing ? "Edit Partner" : "Create Partner"}
                  </h2>
                  <button
                    className="rounded-md border px-3 py-1"
                    onClick={() => {
                      setOpen(false);
                      setEditing(null);
                    }}
                  >
                    Close
                  </button>
                </div>
                <PartnerForm
                  initial={editing}
                  onSubmit={onSubmit}
                  loading={createMut.isPending || updateMut.isPending}
                  onCancel={() => {
                    setOpen(false);
                    setEditing(null);
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </Shell>
  );
};

export default PartnersPage;
